export const COPY_PRODUCTS_BETWEEN_WISHLISTS = /* GraphQL */ `
    mutation copyProductsBetweenWishlists(
        $sourceWishlistUid: ID!
        $destinationWishlistUid: ID!
        $wishlistItems: [WishlistItemCopyInput!]!
    ) {
        copyProductsBetweenWishlists(
            sourceWishlistUid: $sourceWishlistUid
            destinationWishlistUid: $destinationWishlistUid
            wishlistItems: $wishlistItems
        ) {
            destination_wishlist {
                id
                name
            }
        }
    }
`
